module.exports = __webpack_public_path__ + "media/application/images/2018/insta-red-0ef70d89bd8beac36be8f58e1065fcad.svg";